export default __webpack_public_path__ + "static/media/payment-confirmation-1.7a9180b8.jpg";